/** A timestamp as the reader's own calendar date, or the timestamp as sent when it cannot be read. */
export const dateOf = (iso: string): string => {
  const at = new Date(iso);

  return Number.isNaN(at.getTime()) ? iso : at.toLocaleDateString();
};
